<template lang="pug">
form.section.content(v-on:submit.prevent="submit")
  .field
    .control.is-expanded
      input.input(autocomplete="email" placeholder="Email" ref="focus" type="email" v-bind:class="[$v.email.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.email.$model")
    .help.is-danger(v-show="$v.email.$error && !$v.email.email") Email is invalid.
    .help.is-danger(v-show="$v.email.$error && !$v.email.required") Email is required.
  .field
    .control
      button.button.is-fullwidth.is-primary(type="submit" v-bind:disabled="$v.$invalid") Reset Password
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'

import ApiMixin from '@/mixins/ApiMixin.vue'
import DeviceMixin from '@/mixins/DeviceMixin.vue'

export default {
  mixins: [
    ApiMixin,
    DeviceMixin
  ],
  data () {
    return {
      email: null
    }
  },
  mounted () {
    this.deviceSetFocus()
  },
  methods: {
    submit () {
      this.apiResetPassword(this.email)
    }
  },
  validations () {
    return {
      email: {
        email,
        required
      }
    }
  }
}
</script>
